import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const ProjectsDetailsBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Project" subTitle="Details" smText='Project Details'></Breadcrumb>
        </>
    );
};

export default ProjectsDetailsBreadcrumb;